module.exports = __webpack_public_path__ + "img/KongWei.5e76de3b.jpg";